import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "@i18n/hooks";
import { type ViewExternalLicensePoolButtonProps } from "./view-external-license-pool-button.interface";
import { Paths } from "../../../routes/paths";

export const ViewExternalLicensePoolButton = ({
	externalLicensePoolId,
}: ViewExternalLicensePoolButtonProps) => {
	const { t } = useTranslation("common");
	const navigate = useNavigate();

	return (
		<Button
			icon="pi pi-eye"
			tooltip={t("externalLicenses.viewPoolTooltip")}
			onClick={() => {
				navigate(Paths.externalLicensePools.withId(externalLicensePoolId).path);
			}}
		/>
	);
};
